module.exports = __webpack_public_path__ + "img/hmm_background.9becb1b0.png";